import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerAddEditMeal from '../components/TrackerAddEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeDietMeal } from '../helpers/normalizers';
import { DietMealProps } from '../types';

const TrackerAddDietMealContainer: React.FC<DietMealProps & { dietMealId?: string }> = (props) => {
  const normalizedProps = normalizeDietMeal(props);
  sessionStorage.setItem('tracker_depth', '1');
  return (
    <TrackerAddEditMeal
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      dietMealId={props.dietMealId}
    />
  );
};

export default withLoading(TrackerAddDietMealContainer, UniversalPlaceholder);
